import { render, staticRenderFns } from "./IconDelete.vue?vue&type=template&id=3d5a1274&"
var script = {}
import style0 from "./IconDelete.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/lasso/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d5a1274')) {
      api.createRecord('3d5a1274', component.options)
    } else {
      api.reload('3d5a1274', component.options)
    }
    module.hot.accept("./IconDelete.vue?vue&type=template&id=3d5a1274&", function () {
      api.rerender('3d5a1274', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/icons/IconDelete.vue"
export default component.exports